import React, { useEffect } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux"
import { vendordataSelector, vendordata_updateActiveVendor,vendordata_setBanksFromSearch } from "reducers/vendordata/vendordata"
import { Button } from "@mui/material";
import classnames from "classnames";
import { appdataSelector } from "reducers/appdata/appdata";

function VendorEditableBankSearchDatagrid(props) {
    const vendordata = useSelector(vendordataSelector);
    const appdata = useSelector(appdataSelector);
    const [selectionModel, setSelectionModel] = React.useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        //once
        console.log('selectionmodel updated', selectionModel);
        console.log("selected", vendordata.banks[selectionModel]);
    }, [selectionModel]);

    const handleCancel = () => {
        dispatch(vendordata_setBanksFromSearch({}))
    }
    const handleAddBank = () => {
        console.log("add current selected bank", vendordata.banks[selectionModel]);
        let newBank = { ...vendordata.banks[selectionModel] }
        newBank['REQ_ID'] = appdata.activeRequestID;
        let key = "0";

        if (vendordata.activeVendor.BANK && Object.keys(vendordata.activeVendor.BANK[0]).length > 1) {
            console.error("add bank to existing banks")
            key = Object.keys(vendordata.activeVendor.BANK).length
            let lastSeq = parseInt(vendordata.activeVendor.BANK[Object.keys(vendordata.activeVendor.BANK).length - 1]["SEQ"]);
            let newSeq = lastSeq + 1;
            newBank['SEQ'] = newSeq;
        }
        else {
            console.log("add bank as new bank")
            newBank['SEQ'] = 0;
        }

        console.log("newBank", newBank);
        dispatch(
            vendordata_updateActiveVendor({
                part: "BANK",
                key: key,
                value: newBank
            }))


        //dispatch(vendordata_addBank({ bank: vendordata.banks[selectionModel] ,activeRequestID:appdata.activeRequestID}));
    }

    const columns = [
        {
            field: "BANK_NAME",
            headerName: "Name",
            width: 200
        },
        {
            field: "BANK_COUNTRY",
            headerName: "Country",
            width: 100
        },
        {
            field: "BANK_CITY",
            headerName: "City",
            width: 200
        },
        {
            field: "BANK_STREET",
            headerName: "Street",
            width: 200
        },
        {
            field: "BANK_SWIFT",
            headerName: "SWIFT",
            width: 200
        },
        {
            field: "BANK_CODE",
            headerName: "Bank Code",
            width: 100
        },
        {
            field: "BANK_BRANCH",
            headerName: "Branch",
            width: 100
        },
    ]

    return <div style={{ minHeight: 400, width: "100%", marginTop: "20px" }}>
        {vendordata.banks && (
            <DataGrid
                initialState={{
                    pagination: { paginationModel: { pageSize: 10 } },
                }}
                disableColumnSelector
                disableDensitySelector
                getRowId={(row) => row.ID}
                rows={vendordata.banks ? vendordata.banks : []}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5]}
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                    toolbar: {
                        showQuickFilter: true,
                        printOptions: { disableToolbarButton: true },
                        csvOptions: { disableToolbarButton: true }
                    },
                }}
                /* checkboxSelection */
                /*  onCellClick={props.onRowClick}  */

                onRowSelectionModelChange={(newSelectionModel, details) => {
                    setSelectionModel(newSelectionModel);
                }}
                selectionModel={selectionModel}
            />
        )}
        <div className="text-right m-4">
            <Button
                className={classnames("besiButton", "d-print-none", "mt-2", "declineButton", "mr-2")}
                variant="contained"
                color="error"
                key="addcontactbutton3"
                onClick={() => handleCancel()}
            >
                Cancel
            </Button>
            <Button
                className={classnames("besiButton", "d-print-none", "mt-2")}
                variant="contained"
                key="addcontactbutton4"
                onClick={() => handleAddBank()}
            >
                Add Bank
            </Button> </div>
    </div>
}
export default VendorEditableBankSearchDatagrid